/* eslint-disable import/no-mutable-exports */
// eslint-disable-next-line import/extensions
import common from '../assets/text/common.json';

let appCopy = common;

export default function setAppCopy(values) {
  appCopy = { ...values, ...common };
  if (!Object.isFrozen(appCopy)) {
    Object.freeze(appCopy);
  }
}
export { appCopy };
